(function () {
  if (window.__costieraRevealInit) return;
  window.__costieraRevealInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    // Theme editor: Shopify re-renders a section on every setting change
    // (e.g. adding an image), which creates a fresh DOM node the observer
    // below never sees — leaving it stuck at opacity:0 and making the whole
    // section "disappear". In the editor, skip the reveal gating entirely so
    // edited sections always stay visible. The scroll animation still runs
    // normally on the live storefront.
    if (window.Shopify && window.Shopify.designMode) return;

    document.documentElement.classList.add('costiera-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    document.querySelectorAll('[data-costiera-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
